import React from "react";

export default function Footer() {
  return (
    <div>
      <footer class=" text-center lg:text-left bg-indigo-900 border shadow-sm">
        <div className="text-white text-center p-8 pt-8   bg-indigo-900">
          © 2022 Copyright : Xanda Nawzad  
        </div>
      </footer>
    </div>
  );
}
